export const ProjConstants = {
  HOME_ROUTE: '/',
  PARAM_SEPARATOR: '__',
  STATE_UUID: '6f86292b-dd9a-4987-bb8f-c3940263b349',
  FORECAST_STATE_UUID: '2b9beab2-1495-4f05-b4da-29761ebeb2ee',
  STATE_NAME: 'AP',
  FORECAST_STATE_NAME: 'ANDHRA PRADESH',
  STATE_BOUNDS: [[12.60004, 76.75599], [19.15689, 84.76102]],
  FORECAST_WORKSPACE_NAME: 'forecast',
  APWRIMS_WORKSPACE_NAME: 'APWRIMS',
  ADMIN_PANEL_UUID: '1275e5d8-ac8c-4052-85ab-e30d4d61d62b',
  GROUPS_UUID: 'a0ab9554-2af3-4d80-a227-807e323ddea5'
};

export const PROJECT_CONSTANTS = {
  APPLICATION_NAME:'App Builder',
  USERMGMT_APP_NAME: 'User Management'
}

export const Charts : string[] = ['barChart', 'lineChart', 'pieChart','donutChart', 'stackBarChart', 'fixedBarChart']

export type AppBuilderPermissionKeys = keyof typeof APP_BUILDER_PERMISSIONS;
export type AppBuilderPermissionValues = (typeof APP_BUILDER_PERMISSIONS)[AppBuilderPermissionKeys];

export interface IAppBuilderPermissions {
  createProject: 'CreateProject';
  editProject: 'EditProject';
  deleteProject: 'DeleteProject';
  webApplication: 'WebApplication';
  mobileApplication: 'MobileApplication';
  CopyProject:'CopyProject';
  themes: 'Themes';
  addPage: 'AddPage';
  copyPage: 'CopyPage';
  editPage: 'EditPage';
  deletePage: 'DeletePage';
  viewPages: 'ViewPages';
  addEntity: 'AddEntity';
  editEntity: 'EditEntity';
  deleteEntity: 'DeleteEntity';
  entities: 'Entities';
  customApis: 'CustomAPIs';
  editApi: 'EditAPI';
  addApi: 'AddAPI';
  deleteApi: 'DeleteAPI';
  appSettings: 'AppSettings';
  editAppSettings: 'EditAppSettings';
  metrics: 'Metrics';
  viewData: 'ViewData';
  uploadData: 'UploadData';
  downloadData: 'DownloadData';
  deleteData: 'DeleteData';
  editData: 'EditData';
  policy: 'Policy';
  editPolicy: 'EditPolicy';
  media: 'Media';
  editMedia: 'EditMedia';
  deleteMedia: 'DeleteMedia';
  uploadMedia: 'UploadMedia';
  publish: 'Publish';
}

export const APP_BUILDER_PERMISSIONS: IAppBuilderPermissions = {
  createProject: 'CreateProject',
  editProject: 'EditProject',
  deleteProject: 'DeleteProject',
  webApplication: 'WebApplication',
  mobileApplication: 'MobileApplication',
  CopyProject:'CopyProject',
  themes: 'Themes',
  addPage: 'AddPage',
  copyPage: 'CopyPage',
  editPage: 'EditPage',
  deletePage: 'DeletePage',
  viewPages: 'ViewPages',
  addEntity: 'AddEntity',
  editEntity: 'EditEntity',
  deleteEntity: 'DeleteEntity',
  entities: 'Entities',
  customApis: 'CustomAPIs',
  editApi: 'EditAPI',
  addApi: 'AddAPI',
  deleteApi: 'DeleteAPI',
  appSettings: 'AppSettings',
  editAppSettings: 'EditAppSettings',
  metrics: 'Metrics',
  viewData: 'ViewData',
  uploadData: 'UploadData',
  downloadData: 'DownloadData',
  deleteData: 'DeleteData',
  editData: 'EditData',
  policy: 'Policy',
  editPolicy: 'EditPolicy',
  media: 'Media',
  editMedia: 'EditMedia',
  deleteMedia: 'DeleteMedia',
  uploadMedia: 'UploadMedia',
  publish: 'Publish',
};

export const PERMISSIONS_ACTIONS = {
  read:'READ',
  edit:'EDIT',
  delete:'DELETE'
}

export const ACCESS_TOKEN_SYNONYMS = ['access_token','bearer_token','auth_token','api_token','token'];
